import {TrackEvent} from "@next/eventservice"

const TrackEventESB = new TrackEvent()

export const PublishTrackEvent = (eventName: string, data: any) => {
    TrackEventESB.publish({event: eventName, data})
}
